import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import TimeChangeProcessor from '../../components/TimeChange.vue';
import ToolDescription from '../../components/ToolDescription.vue';
export default {
  __name: 'TimeChangePage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "时间转换工具",
        "current-page": "timechange"
      }, {
        default: _withCtx(() => [_createVNode(ToolDescription, {
          title: "时间转换工具使用说明",
          description: "时间转换工具可以帮助您在不同时间格式之间进行快速转换，支持多种时间格式和时区转换功能。",
          features: [{
            title: '时间戳转换',
            description: '在Unix时间戳和人类可读时间格式之间转换'
          }, {
            title: '时区转换',
            description: '查看不同时区的当前时间或特定时间'
          }, {
            title: '日期计算',
            description: '计算两个日期之间的天数、工作日或添加/减去时间'
          }, {
            title: '格式转换',
            description: '支持多种日期格式的相互转换'
          }]
        }), _createVNode(TimeChangeProcessor)]),
        _: 1
      });
    };
  }
};